import { reactOnCms } from 'common/js/react_on_cms';
import BookingExpiry from 'components/booking_expiry';
import Experience from 'components/experience';
import BookingForm from 'tenants/cccsyd/booking_form';

reactOnCms.register({
  BookingForm,
  Experience,
  BookingExpiry,
});
